module.exports = __webpack_public_path__ + "static/media/YB5F18_7.942226a9.jpg";